import { Controller } from "@hotwired/stimulus"

// Copies a value to the clipboard and swaps the button's icon and label to "copied" for a moment.
export default class extends Controller {
  static targets = ["idle", "done"]
  static values = { text: String }

  async copy() {
    await navigator.clipboard.writeText(this.textValue)
    this.toggle(true)
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => this.toggle(false), 2000)
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }

  toggle(copied) {
    this.idleTargets.forEach((element) => element.classList.toggle("hidden", copied))
    this.doneTargets.forEach((element) => element.classList.toggle("hidden", !copied))
  }
}
